import {
  Alert as ChakraAlert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  Button,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

interface MaybernAlertProps {
  primaryAction: {
    title: string;
    onClick?: () => void;
    to?: string;
  };
  secondaryAction?: {
    title: string;
    onClick?: () => void;
    to?: string;
  };
  description?: React.ReactNode;
}

const Alert: React.FC<AlertProps & MaybernAlertProps> = ({
  primaryAction,
  secondaryAction,
  description,
  ...props
}) => (
  <ChakraAlert {...props}>
    <AlertIcon />
    <AlertDescription>{description}</AlertDescription>
    {secondaryAction && (
      <Button variant="link" onClick={secondaryAction.onClick}>
        {secondaryAction.title}
      </Button>
    )}
    <ChakraLink as={Link} to={primaryAction.to} onClick={primaryAction.onClick}>
      {primaryAction.title}
    </ChakraLink>
  </ChakraAlert>
);

export default Alert;
